<template>
  <b-alert class="d-flex align-items-center justify-content-between w-full" show variant="secondary">
    <strong>{{ title }}</strong>
    <div v-if="link">
      <router-link :to="link" class="btn btn-light mx-0 btn-sm">
        <i class="fa fa-chevron-left fa-lg"></i> 
        Volver
      </router-link>
    </div>
  </b-alert>
</template>

<script>

export default {

  name: 'InventoryComponentBreadcrumb',

  props: {
    title: {
      type: [String,Number],
      required: true,
      default: "Información"
    },
    link: {
      type: String,
      required: false,
      default: ""
    }
  }

};

</script>
